import api from './api';

export interface MasterField {
  id: string;
  label: string;
  type: string;
  description: string;
  example: string;
  category: string;
  active: boolean;
  required: boolean;
}

export interface HandoffField {
  id: string;
  label: string;
  type: string;
  required: boolean;
  order: number;
  source: 'master' | 'custom';
  description: string;
  example: string;
}

export interface HandoffConfig {
  fields: HandoffField[];
  max_fields?: number;
}

export interface MasterHandoffConfig {
  fields: MasterField[];
  max_fields?: number;
}

const handoffApi = {
  fetchMasterFields: async (): Promise<MasterHandoffConfig> => {
    const response = await api.get('/handoff/master-fields');
    return response.data;
  },

  fetchHandoffConfig: async (smbId: string): Promise<HandoffConfig> => {
    const response = await api.get(`/smbs/${smbId}/handoff-config`);
    return response.data;
  },

  saveHandoffConfig: async (smbId: string, config: HandoffConfig): Promise<void> => {
    await api.post(`/smbs/${smbId}/handoff-config`, config);
  },
};

export default handoffApi;
